import apiService from '../../../../services/api';

export const getCourseFileUrl = (filePath) => {
  if (!filePath || typeof filePath !== 'string') {
    return '';
  }

  if (/^https?:\/\//i.test(filePath)) {
    return filePath;
  }

  const normalizedPath = filePath.replace(/\\/g, '/');
  const fileName = normalizedPath.split('/').pop();

  return fileName ? `${apiService.baseURL}/course-files/${encodeURIComponent(fileName)}` : '';
};

export const normalizeExternalUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return '';
  }

  const trimmedUrl = url.trim();
  if (!trimmedUrl) {
    return '';
  }

  const withScheme = /^[a-z][a-z\d+.-]*:/i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
  // Only web links are ever opened. javascript:, data: and the like come back empty, which
  // also neutralizes any such link that was stored before links were validated.
  return /^https?:\/\//i.test(withScheme) ? withScheme : '';
};

// A reading's links are shown with the label the instructor gave them. The server fills a missing label with the
// address itself, and an address is not a useful button label, so that counts as "no label".
export const readingLinkLabel = (label, index, total) => {
  const text = typeof label === 'string' ? label.trim() : '';
  if (text && !/^https?:\/\//i.test(text)) return text;
  return total > 1 ? `Link ${index + 1}` : 'View';
};

// Old readings kept their link as plain text inside the description (it is shown as a button instead, so the text
// is removed). Only visible text is touched: a link's address and an image's source are attributes and are kept.
export const removeBareUrlsFromHtml = (html) => {
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);
  textNodes.forEach((node) => { node.nodeValue = node.nodeValue.replace(/https?:\/\/[^\s]+/g, ''); });
  doc.body.querySelectorAll('a').forEach((anchor) => { if (!anchor.textContent.trim() && !anchor.querySelector('img')) anchor.remove(); });
  return doc.body.innerHTML.trim();
};
